import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { isAkunMandor } from "../helpers/auth";

// Halaman yang boleh dibuka akun mandor (lihat juga pembatasan jalur di
// backend: middlewares/access.go). Panduan ikut diizinkan supaya mandor tetap
// bisa membaca cara memakai halamannya.
export const JALUR_MANDOR = "/pembangunan-saya";
export const JALUR_PANDUAN = "/panduan";

const Authmiddleware = ({ children }) => {
  const location = useLocation();

  const token = Cookies.get("access_token");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Akun mandor hanya boleh membuka halaman pekerjaannya dan panduan.
  // Penjaga ini untuk kenyamanan pemakaian; pembatasannya sendiri ditegakkan
  // di backend.
  if (
    isAkunMandor() &&
    location.pathname !== JALUR_MANDOR &&
    location.pathname !== JALUR_PANDUAN
  ) {
    return <Navigate to={JALUR_MANDOR} replace />;
  }

  return <>{children}</>;
};

export default Authmiddleware;
